<template>
  <Modal title="添加渠道" v-model="visible">
    <Form class="form" ref="createChannelForm" :rules="channelRules" :model="createChannelParams">
      <Row>
        <FormItem :label-width="90" label="渠道名称：" prop='channelName'>
          <Input v-model="createChannelParams.channelName" placeholder="请输入渠道名称"></Input>
        </FormItem>
        <FormItem :label-width="90" label="获客终端：" prop='channelType'>
          <Select v-model="createChannelParams.channelType" clearable>
            <Option value="MOBILE" key="1">手机端</Option>
            <Option value="PC" key="2">PC端</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="90" label="渠道分类：" prop='type'>
          <Select v-model="createChannelParams.type" clearable>
            <Option v-for="item in $constant.channelTypeEnum" :value="item.id" :key="item.id">{{ item.text }}</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="90" label="渠道参数：" prop='channelParam'>
          <Input v-model="createChannelParams.channelParam" placeholder="请输入渠道参数"></Input>
        </FormItem>
        <FormItem :label-width="90" label="渠道状态：" prop='status'>
          <Select v-model="createChannelParams.status">
            <Option value="0" key="1">禁用</Option>
            <Option value="1" key="2">启用</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="90" label="来源：" prop='tchChannel'>
          <Select v-model="createChannelParams.tchChannel">
            <Option v-for="item in $constant.tchChannel" :value="item.code" :key="item.code">
              {{ item.text }}
            </Option>
          </Select>
        </FormItem>
        <FormItem :label-width="90" label="渠道描述：">
          <Input v-model="createChannelParams.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                 placeholder="请输入渠道描述"/>
        </FormItem>
        <Form-item :label-width="90" label="市场专员">
          <AdminUserMultSelect :status="1" adminGroupCode="marketGroup" v-model="createChannelParams.adminUserIds"></AdminUserMultSelect>
        </Form-item>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible = false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAddActivity" @click="createNewChannel">确定</Button>
    </div>
  </Modal>
</template>
<script>
import AdminUserMultSelect from '../../common/AdminUserMultSelect';

export default {
  name: 'CreateChannelModal',
  components: {AdminUserMultSelect},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    user: {
      type: Object
    },
    successCallback: {
      type: Function
    }
  },
  data() {
    let $constant = this.$constant
    return {
      visible: this.value,
      bookMaterialLevelList: null,
      loadingAddActivity: false,
      adviserList: [],
      date: [],
      createChannelParams: {
        id: 0,
        channelName: '',
        channelType: '',
        channelParam: '',
        type: '',
        status: 1,
        tchChannel: 1,
        description: '',
        createTime: '',
        updateTime: '',
        adminUserIds: []
      },
      channelRules: {
        channelName: [
          {type: 'string', required: true, message: '请输入渠道名称', trigger: 'blur'}
        ],
        channelType: [
          {type: 'string', required: true, message: '请选择获客终端', trigger: 'blur'}
        ],
        type: [
          {type: 'string', required: true, message: '请选择渠道分类', trigger: 'change'}
        ],
        channelParam: [
          {type: 'string', required: true, message: '请输入渠道参数', trigger: 'blur'}
        ],
        status: [
          {type: 'string', required: true, message: '请选择渠道状态', trigger: 'blur'}
        ],
        tchChannel: [
          {type: 'integer', required: true, message: '请选择渠道来源', trigger: 'blur'}
        ],
      },
    }
  },
  methods: {
    createNewChannel() {
      let self = this
      self.loadingAddActivity = true
      self.$refs.createChannelForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingAddActivity = false
          return
        }
        self.$http.post('/channel/save', self.createChannelParams).then(function (res) {
          if (res && res.data > 0) {
            self.visible = false
            self.$Message.success('创建成功!')
            self.successCallback()
            self.date = []
          }
          self.loadingAddActivity = false
        }).catch(function (e) {
          self.showAddActivityModal = false
          self.loadingAddActivity = false
        })
      })
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      if (val === true) {
        this.createChannelParams = {
          id: 0,
          channelName: '',
          channelType: '',
          channelParam: '',
          type: '',
          status: '',
          description: '',
          createTime: '',
          updateTime: '',
          adminUserIds: []
        }
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CreateChannelModal.vue?790b7acb